import { Components, Theme } from "@mui/material";
import { ButtonStyle } from "./button-override";
import { DialogStyle } from "./dailog-override";
import { PopoverStyle } from "./popover-override";
import { SelectStyle } from "./select-override";
import { InputStyle } from "./text-field-override";

export const overridesStyles = (theme: Theme): Components => ({
  ...ButtonStyle(theme),
  ...InputStyle(theme),
  ...SelectStyle(theme),
  ...DialogStyle(theme),
  ...PopoverStyle(theme),
});
